import * as React from "react";

function SvgAlexa(props, ref) {
  return (
    <svg
      id="Alexa_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 232.6 232.5"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style />
      <radialGradient
        id="Alexa_svg__SVGID_1_"
        cx={116.272}
        cy={1021.625}
        r={166.627}
        gradientTransform="translate(0 -856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.015} stopColor="#98d9ed" />
        <stop offset={0.645} stopColor="#6da6d9" />
        <stop offset={0.951} stopColor="#27326f" />
      </radialGradient>
      <circle
        cx={109.2}
        cy={109.2}
        r={101.2}
        fill="url(#Alexa_svg__SVGID_1_)"
      />
      <radialGradient
        id="Alexa_svg__SVGID_00000072962225063233444280000018172220557291289252_"
        cx={115.859}
        cy={1012.434}
        r={156.912}
        gradientTransform="translate(0 -856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.345} stopColor="#53a5db" />
        <stop offset={0.813} stopColor="#21275e" />
      </radialGradient>
      <circle
        cx={109.2}
        cy={103.3}
        r={95.3}
        fill="url(#Alexa_svg__SVGID_00000072962225063233444280000018172220557291289252_)"
      />
      <radialGradient
        id="Alexa_svg__SVGID_00000021083888711327746890000008077542264686689180_"
        cx={111.494}
        cy={1025.398}
        r={137.965}
        gradientTransform="translate(0 -856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6da6d9" />
        <stop offset={0.429} stopColor="#27326f" />
        <stop offset={1} stopColor="#07070c" />
      </radialGradient>
      <circle
        cx={109.8}
        cy={111.3}
        r={83.8}
        fill="url(#Alexa_svg__SVGID_00000021083888711327746890000008077542264686689180_)"
      />
      <radialGradient
        id="Alexa_svg__SVGID_00000046316594701718103910000000020580076314569607_"
        cx={-160.373}
        cy={897.633}
        r={125.485}
        gradientTransform="matrix(1.0586 0 0 1.0391 281.456 -815.376)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.443} stopColor="#010101" />
        <stop offset={0.872} stopColor="#fff" />
      </radialGradient>
      <ellipse
        cx={109.2}
        cy={67.3}
        rx={69.3}
        ry={54.9}
        opacity={0.7}
        fill="url(#Alexa_svg__SVGID_00000046316594701718103910000000020580076314569607_)"
      />
      <g>
        <path
          d="M163.5 164c-3.5 1.3-6.6 2.3-9.3 3.1s-5.7 1.2-9 1.2c-5.8 0-10.5-1.4-14-4.1-3.5-2.7-5.7-6.7-6.7-12h-.7c-4.9 5.4-10.1 9.5-15.7 12.3s-12.3 4.3-20.1 4.3c-8.3 0-15.1-2.5-20.5-7.6s-8-11.7-8-20c0-4.3.6-8.1 1.8-11.4 1.2-3.4 3-6.4 5.4-9.1 1.9-2.2 4.3-4.2 7.4-6s5.9-3.2 8.6-4.2c3.4-1.3 10.2-3.6 20.5-7.1 10.3-3.4 17.2-6.1 20.8-8.1V84.2c0-1-.2-2.8-.6-5.6-.4-2.8-1.3-5.4-2.6-7.9-1.5-2.8-3.6-5.2-6.3-7.2-2.7-2.1-6.6-3.1-11.6-3.1-3.4 0-6.6.6-9.6 1.7-3 1.2-5 2.4-6.2 3.6 0 1.5.4 3.7 1.1 6.6s1.1 5.6 1.1 8.1c0 2.6-1.2 5-3.5 7.2-2.4 2.2-5.6 3.3-9.8 3.3-3.7 0-6.5-1.3-8.3-4-1.8-2.7-2.6-5.6-2.6-8.9 0-3.4 1.2-6.7 3.6-9.9 2.4-3.1 5.6-6 9.5-8.4 3.4-2.1 7.4-3.9 12.2-5.3 4.8-1.5 9.5-2.2 14-2.2 6.3 0 11.8.4 16.4 1.3 4.7.9 8.9 2.7 12.7 5.6 3.8 2.8 6.7 6.5 8.7 11.3s3 10.9 3 18.4c0 10.7-.1 20.2-.3 28.5s-.3 17.3-.3 27.1c0 2.9.5 5.2 1.5 7 1 1.7 2.6 3.2 4.7 4.4 1.1.7 2.9 1.1 5.3 1.1 2.4.1 4.9.1 7.5.1l-.1 7zm-39.1-59.3c-6.4 1.9-11.9 3.7-16.7 5.5s-9.2 4.1-13.4 6.7c-3.7 2.6-6.7 5.6-8.9 9.1s-3.3 7.6-3.3 12.4c0 6.2 1.6 10.8 4.9 13.7s7.4 4.4 12.4 4.4c5.3 0 10-1.3 14-3.9 4-2.6 7.4-5.6 10.2-9.2l.8-38.7z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAlexa);
